import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Popover from '@mui/material/Popover';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Dialog from '/@/components/dialog';
import MyRecommendationsFilter from '/@/components/my-recommendations/filter';
import NOLItemList from '/@/components/new-overlay-list/item-list';
import useOverlayConfig from '/@/hooks/my-recommendations/useOverlayConfig';
import { _ } from '/@/locale';
import { setSelectedFeature } from '/@/store/nav/actions';
import { reverse } from '/@/utils/router';
import Title from '/@/v3/components/title';
import styles from '../styles.module.css';

const CustomizedDivider = styled(Divider)`
    margin-left: 0px;
    margin-right: 0px;
`;

const MyRecommendationsHeader = ({
    recommendations,
    filterRecos,
    setFilterRecos,
    showFilter,
    selected,
    setShowFilter,
    setSelected,
    setOpenSnack,
    deleteRecommendations,
    filterOptions,
}) => {
    const [showPopupDelete, setShowPopupDelete] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const overlayConfig = useOverlayConfig();
    const history = useNavigate();
    const dispatch = useDispatch();
    const setSelectedFeatureAction = bindActionCreators(setSelectedFeature, dispatch);
    useEffect(() => {
        setFilterRecos({ ...filterRecos, search: searchInput });
    }, [searchInput]);

    const handleInputFilter = (e) => {
        setSearchInput(e.target.value);
    };

    const handleClickNewReco = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseNewReco = () => {
        setAnchorEl(null);
    };

    const handleClickReco = (e) => {
        const data = { view: 'Home', selectedFeature: 'recommendation', crop: e.type };
        setSelectedFeatureAction(data);
        history(reverse(data.view));
    };

    const handleDeleteRecommendations = async () => {
        (async () => {
            await deleteRecommendations({ ids: selected });
        })();
        setShowFilter(true);
        setShowPopupDelete(false);
        setOpenSnack(true);
        setSelected([]);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <Grid container spacing={2} direction='row' justifyContent='space-between' alignItems='center'>
            <Grid item xs={12} sm={4} lg={5}>
                <Title className={styles.titleMyRecommendations}>{_('Mis Recomendaciones')}</Title>
            </Grid>
            <Grid item xs={12} sm={4} lg={3}>
                <TextField
                    value={searchInput}
                    onChange={handleInputFilter}
                    onReset={() => setSearchInput('')}
                    label={_('Buscar por lote, tipo, fecha, etc.')}
                    size='small'
                    fullWidth
                />
            </Grid>
            {overlayConfig.length > 0 && (
                <Grid item xs={12} sm={4} lg={4}>
                    <Button variant='contained' fullWidth onClick={handleClickNewReco}>
                        {_('Crear Nueva Recomendación')}
                    </Button>
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleCloseNewReco}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                    >
                        <NOLItemList itemList={overlayConfig} selectItem={handleClickReco} />
                    </Popover>
                </Grid>
            )}
            <Grid item xs={12}>
                <CustomizedDivider variant='middle' />
            </Grid>
            {showFilter ? (
                <Grid item xs={12}>
                    <MyRecommendationsFilter
                        onChangeFilters={setFilterRecos}
                        filters={filterRecos}
                        filterOptions={filterOptions}
                        setSearchInput={setSearchInput}
                    />
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <Grid container spacing={2} justifyContent='flex-end'>
                        <Grid item xs={12} sm={4} lg={3}>
                            <Button variant='outlined' color='error' onClick={() => setShowPopupDelete(true)}>
                                {_('Eliminar Recomendación')}
                                {` (${selected.length})`}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            )}
            <Dialog
                title={`${_('Eliminar')} (${selected.length})`}
                message={`${_('¿Estás seguro que querés eliminar')}${
                    selected.length === 1
                        ? _(' la recomendación seleccionada?')
                        : _(' las recomendaciones seleccionadas?')
                }`}
                visible={showPopupDelete}
                onClose={() => setShowPopupDelete(false)}
                onCancel={() => setShowPopupDelete(false)}
                onAccept={handleDeleteRecommendations}
                alignCenter
            />
        </Grid>
    );
};

export default MyRecommendationsHeader;

export const MyRecommendationsExpertoHeader = ({ selected, setSelected, setOpenSnack, deleteRecommendations }) => {
    const [showPopupDelete, setShowPopupDelete] = useState(false);

    const handleDeleteRecommendations = () => {
        (async () => {
            await deleteRecommendations({ ids: selected });
        })();
        setShowPopupDelete(false);
        setOpenSnack(true);
        setSelected([]);
    };

    return (
        <Grid
            container
            spacing={1}
            direction='row'
            justifyContent='space-between'
            alignItems='center'
            sx={{ background: (t) => t.palette.gray[200], py: 4, px: 8 }}
        >
            <Grid item container>
                <Grid item xs={6}>
                    <Typography color='primary' variant='h4'>
                        {_('Mis Recomendaciones')}
                    </Typography>
                </Grid>
                {!!selected.length && (
                    <Grid item container justifyContent={'flex-end'} xs={6}>
                        <Grid item>
                            <Button variant='outlined' color='error' onClick={() => setShowPopupDelete(true)}>
                                {_('Eliminar Recomendación')}
                                {` (${selected.length})`}
                            </Button>
                        </Grid>
                    </Grid>
                )}
            </Grid>
            <Grid item>
                <Typography color='primary.mui.inactive' variant='body1'>
                    {_(
                        'Nuestras recomendaciones se basan en sus respuestas, así como en los estudios y tendencias regionales de nuestra base de datos.'
                    )}
                </Typography>
            </Grid>

            <Dialog
                title={`${_('Eliminar')} (${selected.length})`}
                message={`${_('¿Estás seguro que querés eliminar')}${
                    selected.length === 1
                        ? _(' la recomendación seleccionada?')
                        : _(' las recomendaciones seleccionadas?')
                }`}
                visible={showPopupDelete}
                onClose={() => setShowPopupDelete(false)}
                onCancel={() => setShowPopupDelete(false)}
                onAccept={handleDeleteRecommendations}
                alignCenter
            />
        </Grid>
    );
};
